// export const csrfToken : string = document.querySelector("[name='csrf-token']").content;
import { TabInterface } from "@interfaces/index";
export const csrfToken = () => {
  const element = document.querySelector("[name='csrf-token']");
  if (element instanceof HTMLMetaElement) {
    return element.content;
  }
  return undefined;
};
export const UNAUTHORIZED: string = 'UNAUTHORIZED'
export const SET_META: string = "SET_META";
export const APP_LOAD: string = `APP_LOAD`;
export const CHECK_AUTH: string = `CHECK_AUTH`;
export const IS_ERROR: string = `IS_ERROR`;
export const REQUIRED_PLAN: string = `REQUIRED_PLAN`;
export const TOGGLE_MOBILE_NAVIGATION: string = `TOGGLE_MOBILE_NAVIGATION`;
export const SUBSCRIPTION_SHOPIFY_PLUS: string = `SUBSCRIPTION_SHOPIFY_PLUS`

export const API_POINT: string = `${import.meta.env.VITE_BACKEND_BASE_URL}/api`;
export const API_VER: string = "v1";
export const TOGGLE_SIDER: string = "TOGGLE_SIDER";
export const GET_WINDOW_HEIGHT: string = "GET_WINDOW_HEIGHT";
export const OPEN_MODAL_HELP: string = "OPEN_MODAL_HELP";
export const PRODUCT_INDEX_PATH: string = `${API_POINT}/${API_VER}/products.json`;
export const ORDERS_INDEX_PATH: string = `${API_POINT}/${API_VER}/orders.json`;
export const PRODUCT:string = `${API_POINT}/${API_VER}/products/list`
export const SHOPS_PATH: string = `${API_POINT}/${API_VER}/shops`;
export const SHOP_SHOW_PATH: string = `${SHOPS_PATH}/get_shop.json`;
export const SHOP_KEY: string = `SHOP`;
export const UPLOAD_LOGO_SUCCESS: string = "UPLOAD_LOGO_SUCCESS";
export const UPLOAD_LOGO: string = "UPLOAD_LOGO";
export const REMOVE_LOGO: string = "REMOVE_LOGO";
export const GET_SHOP: string = "GET_SHOP";
export const SET_SHOP: string = "SET_SHOP";
export const SET_BOARDING_SHOP: string = "SET_BOARDING_SHOP";
export const SET_CURRENCIES: string = "SET_CURRENCIES";
export const TOAST: string = "TOAST";
export const SHOW_PLAN: boolean = false;
export const IMG_SHOPIFY_ENDPOINT: string = `${API_POINT}/${API_VER}/shops/list_images`
export const IMG_SHOPIFY_UPLOAD: string = `${API_POINT}/${API_VER}/shops/create-shop-image`
// Started preview
export const STARTED_UPLOAD_LOGO: string = `${API_POINT}/${API_VER}/started/upload_logo`

//! Quote
export const CUSTOMER_QUOTE: string = `${API_POINT}/${API_VER}/customers`;
export const QUOTE_ENDPOINT: string = `${API_POINT}/${API_VER}/quotations`;
export const PRODUCT_ENDPOINT: string = `${API_POINT}/${API_VER}/products`;
//! Language
export const LANGUAGE_TRANSLATE: string = `${API_POINT}/${API_VER}/custom_translation_list`
export const LANGUAGE_TRANSLATE_DELETE: string = `${API_POINT}/${API_VER}/custom_translation_delete`
export const LOCALE_PRESETS_PATH: string = `${API_POINT}/${API_VER}/locale_presets`
export const LOCALE_LANGUAGES_PATH: string = `${API_POINT}/${API_VER}/locale_languages`
// Partner

export const GET_PARTNERS: string = `${API_POINT}/${API_VER}/partner`

// Layout
export const GET_LAYOUTS: string = "GET_LAYOUTS";
export const GET_LAYOUTS_PATH: string = `${API_POINT}/${API_VER}/layouts.json`;
export const GET_LAYOUT_PATH: string = `${API_POINT}/${API_VER}/layouts`;
export const UPDATE_LAYOUT_PATH: string = `${API_POINT}/${API_VER}/layouts`;
export const CHOOSE_LAYOUT: string = `CHOOSE_LAYOUT`;
export const CREATE_LAYOUT_SUCCESSFUL: string = `CREATE_LAYOUT_SUCCESSFUL`;

// Page Form
export const UPDATE_PAGE_FORM: string = "UPDATE_PAGE_FORM";
export const UPDATE_LAYOUTS_SUCCESS: string = "UPDATE_LAYOUTS_SUCCESS";

// Tempplates
export const THEMES_PATH: string = `${API_POINT}/${API_VER}/themes`;
export const THEMES_UPGRADE: string = `${API_POINT}/${API_VER}/theme_upgrade`
export const SHOW_THEME: string = `SHOW_THEME`;
export const OPEN_OPTION: string = `OPEN_OPTION`;
export const OPEN_NAVIGATE: string = `OPEN_NAVIGATE`;
export const CHANGE_THEME: string = `CHANGE_THEME`;
export const CHANGE_THEME_SUCCESSFUL: string = `CHANGE_THEME_SUCCESSFUL`;
export const UPDATE_THEME: string = `UPDATE_THEME`;
export const UPDATE_THEME_SUCCESSFUL: string = `UPDATE_THEME_SUCCESSFUL`;
export const RESET_CHANGE_THEME: string = `RESET_CHANGE_THEME`;
export const PREVIEW_THEME: string = `PREVIEW_THEME`;
export const UPDATE_PREVIEW_THEME: string = `UPDATE_PREVIEW_THEME`;
export const UPDATE_THEME_COMPLETED: string = `UPDATE_THEME_COMPLETED`;
export const CREATE_THEME_SUCCESSFUL: string = `CREATE_THEME_SUCCESSFUL`;
export const DELETE_THEME: string = `DELETE_THEME`;
export const UPLOAD_LOGO_THEME_PATH: string = `${THEMES_PATH}/upload_logo`;
//! Beta reports
export const BETA_REPORT_PATH: string = `${API_POINT}/${API_VER}/beta/report_themes`
export const REPORT_PATH: string = `${API_POINT}/${API_VER}/reports`
// Orders
export const ORDERS_PATH: string = `${API_POINT}/${API_VER}/orders`;
export const ORDER_DETAIL_PATH: string = `${API_POINT}/${API_VER}/order_detail`
export const DRAFT_ORDER_DETAIL_PATH: string = `${API_POINT}/${API_VER}/draft_order_detail`
export const DOWNLOAD_MULTIPLE: string = `DOWNLOAD_MULTIPLE`;
export const GET_ORDERS: string = `GET_ORDERS`;
export const DOWNLOAD_TOGGLE: string = `DOWNLOAD_TOGGLE`;
export const ORDER_SET_QUERY_STRING: string = `ORDER_SET_QUERY_STRING`;
export const CHANGE_TAB: string = `CHANGE_TAB`;
export const SET_MESSAGES: string = `SET_MESSAGES`;
export const CUSTOMER_SYNC_ORDERS: string =`${API_POINT}/${API_VER}/orders/customers_sync_orders`
// Download
export const DOWNLOADS_PATH = `${API_POINT}/${API_VER}/downloads`;
export const DELETE_DOWNLOAD: string = `DELETE_DOWNLOAD`;
export const SHOW_DOWNLOAD: string = `SHOW_DOWNLOAD`;
export const CREATE_LINK_DOWNLOAD: string = `CREATE_LINK_DOWNLOAD`;

// Automation emails
export const AUTOMATION_EMAILS_PATH: string = `${API_POINT}/${API_VER}/automation_emails`;
export const AUTOMATION_EMAIL_HISTORIES_PATH: string = `${API_POINT}/${API_VER}/automation_email_histories`;
export const SHOW_AUTOMATION_EMAIL: string = `SHOW_AUTOMATION_EMAIL`;
export const AUTONATION_SEND_TEST_PATH: string = `${API_POINT}/${API_VER}/automation_emails/send_test`

// Shopify Flow Emails
export const SHOPIFY_FLOW_EMAILS_PATH: string = `${API_POINT}/${API_VER}/shopify_flow_emails`;
// Subscriptions
export const SUBSCRIPTION_PATH: string = `${API_POINT}/${API_VER}/subscriptions`;
export const SUBSCRIPTION_CHECK: string = `${API_POINT}/${API_VER}/subscriptions/callback`;
export const SUBSCRIPTION_DOWNGRADE_FEEDBACK: string =
  `${API_POINT}/${API_VER}/subscriptions/downgrade_feedback`;
export const SUBSCRIPTION_RETENTION_OFFER: string =
  `${API_POINT}/${API_VER}/subscriptions/retention_offer`;
export const SUBSCRIPTION_UPDATE: string = `SUBSCRIPTION_UPDATE`;

// Translation
export const TRANSLATION_PATH: string = `${API_POINT}/${API_VER}/translations`;


export const DRAFT_ORDERS_PATH: string = `${API_POINT}/${API_VER}/draft_orders`;
//Invoice generate
export const INVOICE_GENERATE:string = `${API_POINT}/${API_VER}/invoice_generates`
// Send emails

export const SEND_EMAIL_PATH: string = `${API_POINT}/${API_VER}/send_emails`;
export const SEND_DRAFT_ORDER_EMAIL_PATH: string = `${API_POINT}/${API_VER}/send_emails/draft_orders`;
export const SEND_CHECKOUT_EMAIL_PATH: string = `${API_POINT}/${API_VER}/send_emails/checkout`;
export const CURRENCY_FORMATS_PATH: string = `${API_POINT}/${API_VER}/currency_formats`;
export const GET_ACTIVITIES_PATH: string = `${API_POINT}/${API_VER}/shops/activities`
export const ACTIVITY_LOG_PATH: string = `${API_POINT}/${API_VER}/activities`

export const EMAIL_SETTING_PATH: string = `${API_POINT}/${API_VER}/email_settings`;

// Email verify
export const VERIFY_EMAIL_PATH: string = `${API_POINT}/${API_VER}/shops/verify_email`
export const RESEND_VERIFY_EMAIL_PATH: string = `${API_POINT}/${API_VER}/shops/resend_verify`
export const CREATE_SENDER_PATH: string = `${API_POINT}/${API_VER}/shops/create_sender`
export const UPDATE_SENDER_PATH: string = `${API_POINT}/${API_VER}/shops/update_sender`

// Customize sender address (resend_domain)
export const RESEND_DOMAIN_PATH: string = `${API_POINT}/${API_VER}/shops/resend_domain`
export const RESEND_DOMAIN_VERIFY_PATH: string = `${API_POINT}/${API_VER}/shops/resend_domain/verify`
export const RESEND_DOMAIN_CLOUDFLARE_DNS_PATH: string = `${API_POINT}/${API_VER}/shops/resend_domain/cloudflare_dns`
export const UPDATE_WEBHOOK_DOMAIN_PATH: string = `${API_POINT}/${API_VER}/shops/update_webhook_domain`

// Request features
export const REQUEST_FEATURES: string = `${API_POINT}/${API_VER}/request_features`;

// Discount code
export const DISCOUNT_CODE_PATH: string = `${API_POINT}/${API_VER}/discount_codes`

// GraphQL
export const GRAPHQL_ENDPOINT: string = `${API_POINT}/${API_VER}/graphql`

export const CHECK_EMBED:string = `${API_POINT}/${API_VER}/check_application_status`
export const CHECK_SHOPIFY_PLUS: string = `${API_POINT}/${API_VER}/shops/check_shop_plus`
export const CHECK_OPTIONAL_SCOPES: string = `${API_POINT}/${API_VER}/shops/check_optional_scopes`
export const REDITUS_WIDGET_TOKEN_PATH: string = `${API_POINT}/${API_VER}/reditus/referral-widget-token`
/**
 * Download history
 */
export const DOWNLOAD_HISTORY_ENDPOINT: string = `${API_POINT}/${API_VER}/batch_downloads`

type ChoiceType = {
  label: string;
  value: any;
};
export const ORDER_STATUS: ChoiceType[] = [
  { label: "All", value: "" },
  { label: "Open", value: "Open" },
  { label: "Archived", value: "Archived" },
  { label: "Cancelled", value: "Cancelled" },
];
// authorized: Show only authorized orders
// pending: Show only pending orders
// paid: Show only paid orders
// partially_paid: Show only partially paid orders
// refunded: Show only refunded orders
// voided: Show only voided orders
// partially_refunded: Show only partially refunded orders
// any: Show orders of any financial status.
// unpaid: Show authorized and partially paid orders.
export const PAYMENT_STATUS: ChoiceType[] = [
  { label: "Paid", value: "PAID" },
  { label: "Unpaid", value: "UNPAID" },
  { label: "Authorized", value: "AUTHORIZED" },
  { label: "Partially refunded", value: "PARTIALLY_REFUNDED" },
  { label: "Partially paid", value: "PARTIALLY_PAID" },
  { label: "Pending", value: "PENDING" },
  { label: "Refunded", value: "REFUNDED" },
  { label: "Voided", value: "VOIDED" },
];
export const FULFILLMENT_STATUS: ChoiceType[] = [
  { label: "Fulfilled", value: "FULFILLED" },
  { label: "Unfulfilled", value: "UNFULFILLED" },
  { label: "On hold", value: "ON_HOLD" },
  { label: "Partially Fulfilled", value: "PARTIAL" },
  { label: "Scheduled", value: "SCHEDULED" },
];

export const SALE_CHANNELS: ChoiceType[] = [
  { label: "Point of Sale", value: "Point of Sale" },
  { label: "Online Store", value: "Online Store" },
];

export const currentDate = new Date();
// currentDate.setUTCHours(0, 0, 0, 0);
export const addDays = (days: number, date: Date = currentDate) => {
  let newDate = new Date(date);
  // newDate.setUTCHours(0, 0, 0, 0);
  // let date = currentDate;
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};
export const newAutomationEmail = {
  name: "Untitled automation email",
  description: "",
  theme_id: "",
  trigger_event: "",
  is_skip_template_attachment: false,
  is_active: true,
  send_to_customer: true,
  reply_to: "support@example.com",
  bbc_to: "",
  cc_to: "",
  settings: {
    header_logo_size: 60,
    banner_size: 100,
    footer_logo_size: 60,
    order_show_product_image: true,
    order_show_sub_total: true,
    order_show_total_quantity: false,
    order_show_total: true,
    order_show_shipping_total: true,
    order_show_discount_total: false,
    order_show_discount_item: false,
    order_show_tax_total: true,
    order_show_tax_name: false,
    order_show_shipping_name: false,
    order_show_shipping_tax_total: false,
    order_show_total_weight: false,
    order_show_warehouse_address: false,
    order_show_refund_reason: false,
    order_show_duties_total: false,
    ae_ps_order_show_product_image: true,
    ae_ps_order_product_image_bg: "#ffffff",
    ae_ps_order_product_image_boder_radius: 5,
    ae_ps_order_show_discount_item: true,
    ae_ps_order_show_total_weight: true,
    ae_ps_order_show_total_quantity: true,
    ae_ps_order_show_warehouse_address: true,
    ae_ps_order_show_tracking_info: false,
    ae_rf_order_show_product_image: true,
    ae_rf_order_product_image_bg: "#ffffff",
    ae_rf_order_product_image_boder_radius: 5,
    ae_rf_order_show_discount_item: false,
    ae_rf_order_show_total_weight: false,
    ae_rf_order_show_total_quantity: true,
    ae_rf_order_show_sub_total: true,
    ae_rf_order_show_shipping_total: false,
    ae_rf_order_show_shipping_tax_total: false,
    ae_rf_order_show_refund_reason: true,
    ae_rf_order_show_duties_total: false,
    ae_rf_order_show_tax_total: true,
    ae_rf_order_show_total: true,
    order_font_family: 'Georgia',
    order_sub_total_name: "Subtotal price",
    order_tax_name: "Total tax",
    order_shipping_name: "Total shipping",
    order_shipping_tax_name: "Total shipping tax",
    order_discount_name: "Total discount",
    order_total_quantity_name: "Total quantity",
    order_total_weight_name: "Total weight",
    order_warehouse_address_name: "Warehouse address",
    order_refund_reason_name: "Refund reason",
    order_duties_name: "Duties",
    order_total_name: "Total",
    ae_ps_order_total_weight_name: "Total weight",
    ae_ps_order_total_quantity_name: "Total quantity",
    ae_ps_order_warehouse_address_name: "Warehouse address",
    ae_ps_order_tracking_info_name: "Tracking info",
    ae_rf_order_total_weight_name: "Total weight",
    ae_rf_order_total_quantity_name: "Total quantity",
    ae_rf_order_sub_total_name: "Subtotal price",
    ae_rf_order_shipping_name: "Total shipping",
    ae_rf_order_shipping_tax_name: "Total shipping tax",
    ae_rf_order_refund_reason_name: "Refund reason",
    ae_rf_order_duties_name: "Duties",
    ae_rf_order_tax_name: "Total product tax",
    ae_rf_order_total_name: "Total refund",
    font_family: "Georgia",
    line_height: "1.2",
    font_size: "14px",
    text_color: "#000000"
  },
  email_title: "New order from {{store.name}}",
  email_content: `
    <p>Hi {{customer.display_name}},</p>
    <p>Thank you for your purchase. Please find your invoice attached for your reference. Your order details can be found below:</p>
    {{order_items}}
`,
  footer: `
        <p style="font-family: Georgia; color: {{settings.text_color}};">If you have any questions, contact us.</p>
        <p style="font-family: Georgia; color: {{settings.text_color}};">We are here and always willing to help!</p>
        <p style="font-family: Georgia; color: {{settings.text_color}};">Many thanks for your trust and purchase!</p>
        <p>
          <br>
        </p>
        <p style="font-family: Georgia; color: {{settings.text_color}};">{{store.name}}</p>
        <p style="font-family: Georgia; color: {{settings.text_color}};">{{store.address}}</p>
`,
  liquid_email: " ",
  start_datetime: currentDate,
  end_datetime: addDays(7, currentDate),
  is_end_date: false,
  is_show_copyright: true,
  footer_copyright_content: "@{{year}}{{store.name}}. All rights reserved.",
  
};
export const order_trigger_events = [
  { label: "Triggered when a new order is created", value: "orders/create", plan: 'STARTER' },
  { label: "Triggered when an order is fulfilled or partially fulfilled", value: "orders/fulfilled", plan: "PRO" },
  { label: "Triggered when an order is canceled", value: "orders/cancelled", plan: "PRO" },
  { label: "Triggered when an order is paid", value: "orders/paid", plan: "PRO" },
  { label: "Triggered when a refund is created", value: "refunds/create", plan: "PRO" },
  { label: "Triggered when a draft order is created", value: "draft_orders/create"}
];
export const orderTabs: TabInterface[] = [
  {
    id: `All`,
    content: `ALL`,
    panelID: `AllOrders`,
  },
  {
    id: "UNFULFILLED",
    content: "Unfulfilled",
    panelID: "Unfulfilled",
  },
  {
    id: "Open",
    content: "Open",
    panelID: "Open",
  },
  {
    id: "Archived",
    content: "Closed",
    panelID: "Closed",
  },
];
export const translateTypes: TabInterface[] = [
  {
    id: `General`,
    content: `General`,
    panelID: `GENERAL_LOCALE`,
  },
  {
    id: `Invoice`,
    content: `Invoice`,
    panelID: `INVOICE_LOCALE`,
  },
  {
    id: `Packing_slip`,
    content: `Packing slip`,
    panelID: `PACKING_SLIP_LOCALE`,
  },
  {
    id: `Refund`,
    content: `Refund`,
    panelID: `REFUND_LOCALE`,
  },
  {
    id: `Order`,
    content: `Order`,
    panelID: `ORDER_LOCALE`,
  },
  {
    id: `DraftOrder`,
    content: `Draft Order`,
    panelID: `DRAFT_ORDER_LOCALE`,
  },
  {
    id: `InvoiceReport`,
    content: `Invoice Report`,
    panelID: `INVOICE_REPORT_LOCALE`,
  },
];
export const SEND_INVOICE_EMAIL = `SEND_INVOICE_EMAIL`;

export const DATE_FORMAT = {
  "%m-%d-%Y": "01-15-2020",
  "%m-%d-%Y %H:%M:%S": "01-15-2020 14:00:00",
  "%d-%m-%Y": "15-01-2020",
  "%d-%m-%Y %H:%M:%S": "15-01-2020 14:00:00",
  "%Y-%m-%d": "2020-01-15",
  "%Y-%m-%d %H:%M:%S": "2020-01-15 14:00:00",
  "%m/%d/%Y": "01/15/2020",
  "%m/%d/%Y %H:%M:%S": "01/15/2020 14:00:00",
  "%d/%m/%Y": "15/01/2020",
  "%d/%m/%Y %H:%M:%S": "15/01/2020 14:00:00",
  "%Y/%m/%d": "2020/01/15",
  "%Y/%m/%d %H:%M:%S": "2020/01/15 14:00:00",
  "%d %B, %Y": "15 January, 2020",
  "%d %B, %Y %H:%M:%S": "15 January, 2020 14:00:00",
  "%d %B, %Y %I:%M %p": "15 January, 2020 12:01 AM",
  "%B %d, %Y": "January 15, 2020",
  "%B %d, %Y %I:%M %p": "January 15, 2020 12:01 AM",
  "%Y %B %d": "2020 January 15",
  "%Y %B %d %I %M %p": "2020 January 15 12:01 AM",
  "%m.%d.%Y": "01.15.2020",
  "%m.%d.%Y %H:%M:%S": "01.15.2020 14:00:00",
  "%d.%m.%Y": "15.01.2020",
  "%d.%m.%Y %H:%M:%S": "15.01.2020 14:00:00",
  "%Y.%m.%d": "2020.01.15",
  "%Y.%m.%d %H:%M:%S": "2020.01.15 14:00:00"
}
  // open-sans: 'Open Sans';
  // inter: 'Inter';
  // roboto: 'Roboto';
  // Alegreya: 'Alegreya Sans';
  // Montserrat: 'Montserrat';
  // Lato: 'Lato';
  // Poppins: 'Poppins';
  // Oswald: 'Oswald';
  // Raleway: 'Raleway';
  // Futura: 'Futura'
export const GOOGLE_FONTS = [
  // Font Gmail support
  'Arial',
  'Arial Black',
  'Arial Narrow',
  'Bookman Old Style',
  'Calibri',
  'Cambria',
  'Century Gothic',
  'Comic Sans MS',
  'Courier',
  'Courier New',
  'Franklin Gothic Medium',
  'Garamond',
  'Georgia',
  'Helvetica',
  'Impact',
  'Lucida Console',
  'Lucida Sans Unicode',
  'Lucida',
  'MS Sans Serif',
  'MS Serif',
  'Palatino',
  'Tahoma',
  'Times',
  'Times New Roman',
  'Trebuchet MS',
  'Trebuchet',
  'Verdana',
  'Wingdings',
// Font Gmail not support
  'Open Sans',
  'Inter',
  'Roboto',
  'Alegreya Sans',
  'Montserrat',
  'Lato',
  'Poppins',
  'Oswald',
  'Raleway',
  'Futura'
];
const font_string = GOOGLE_FONTS.map((font) => `${font}:wght@400;700`)
export const GOOGLE_FONTS_URL = `https://fonts.googleapis.com/css2?family=${font_string.join('&family=')}&display=swap`

export const LINE_HEIGHTS = [
    '1.0',
    '1.1',
    '1.2',
    '1.3',
    '1.4',
    '1.5',
    '1.6',
    '1.7',
    '1.8',
    '1.9',
    '2.0',
    '2.1',
    '2.2',
    '2.3',
    '2.4',
    '2.5',
    '2.6',
    '2.7',
    '2.8',
    '2.9',
    '3.0',
    '4.0',
    '5.0',
    '6.0',
    '7.0',
] 

export const TIME_DELAYS: ChoiceType[] = [
  { label: 'Immediately', value: '0' },
  { label: '1 minute', value: '1' },
  { label: '2 minutes', value: '2' },
  { label: '3 minutes', value: '3' },
  { label: '4 minutes', value: '4' },
  { label: '5 minutes', value: '5' },
  { label: '10 minutes', value: '10' },
  { label: '15 minutes', value: '15' },
  { label: '20 minutes', value: '20' },
  { label: '25 minutes', value: '25' },
  { label: '30 minutes', value: '30' },
  { label: '1 hour', value: '60' },
  { label: '2 hours', value: '90' },
  { label: '3 hours', value: '120' },
  { label: '6 hours', value: '180' },
  { label: '9 hours', value: '450' },
  { label: '12 hours', value: '720' },
  { label: '18 hours', value: '1080' },
  { label: '24 hours', value: '1440' },
  { label: '2 days', value: '2880' }
]
